import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  CircularProgress,

} from "@mui/material";
import validate from "../../../validation/validation";
import DisplayError from "../../../validation/DisplayError";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import AddIcon from "@mui/icons-material/Add";
import dayjs from "dayjs";
import { H4FormLabel } from "../../../theme/Theme";
import SelectDropDown from "../../../components/Custom/SelectDropDown";
import ThemeColor from "../../../theme/ThemeColor";
import { InputBox, TextArea } from "../../../components/Custom";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { City , State } from "country-state-city";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import HeaderName from "../../../components/Custom/HeaderName";
import {  getAdminDRSList,} from "../../../redux/Thunk/drsThunk";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { getOfficeList } from "../../../redux/Thunk/officeThunk";
import { getCustomerList } from "../../../redux/Thunk/customerThunk";
import { useNavigate, useLocation } from "react-router";
import { useSelector } from "react-redux";
import { getDeliveryBoyList } from "../../../redux/Thunk/officePickupThunk";
import moment from "moment";
import { roles } from "../../utils/constant";
import {  createPodDetails,updatePODDetails, uploadPodProof} from "../../../redux/Thunk/podThunk";
import { styled } from "@mui/system";
import { getDocket } from "../../../redux/Thunk/officePickupThunk";
import IconButton from '@mui/material/IconButton';
import ImageIcon from '@mui/icons-material/Image';
import Tooltip from '@mui/material/Tooltip';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody,} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const NewPOD = () => {
  const todayDate = dayjs();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [error, setError] = useState([]);
  const [editPodDetails, seteditPodDetails] = useState(
    state?.editDetails ? state?.editDetails : {}
  );
  const [isFormDisabled, setIsFormDisabled] = useState(state?.isDisabled || false);
  const [loader, setLoader] = useState("");
  const [deliveryBoyList, setDeliveryBoyList] = useState();
  const [drsDetails, setDrsDetails] = useState({
    OfficeId: "",
    DeliveryBoyId: "",
    CustomerId: "",
    Remark: "",
    Status: "",
    drsId: "",
    Destination: "",
    Origin: "",
    Cosignee: "",
    Cosigner: "",
    Pckgs: "",
    weight: "",
    BookingDate: null,
    ReceivedBy: "",
    ArrivalTime: null,
    ReceiverMobile: "",
    DeliveryDate: null,
    DestinationReletaion: "",
    DocketId: "",
    proofImage: null,
  });

  const [page, setPage] = useState({
    page: 0,
    pageSize: 10,
  });
  const [pickupIdOptions, setPickupIdOptions] = useState([]);
  const [drsOptions, setDrsOptions] = useState([]); // for dropdown
 const [selectedOption, setSelectedOption] = useState("sign");
  const [previewUrl, setPreviewUrl] = useState(null);
  const [file, setFile] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [drsDetailsList, setDrsDetailsList] = useState([]);
  const officeId = useSelector((state) => state.auth.officeId);
  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  const role = userDetails?.Role;


useEffect(() => {
  if (editPodDetails && Object.keys(editPodDetails).length > 0) {
    const firstPickup = editPodDetails.PickupDetails?.[0] || {};

    // Set form values
    setDrsDetails({
      OfficeId: editPodDetails.OfficeId || "",
      drsId: editPodDetails.DRSId || "",
      ArrivalTime: editPodDetails.GateInDate ? dayjs(editPodDetails.GateInDate) : null,
      Cosignee: firstPickup.Consignee || "",
      Cosigner: firstPickup.Consigner || "",
      BookingDate: firstPickup.PickupDateAndTime ? dayjs(firstPickup.PickupDateAndTime) : null,
      CustomerId: editPodDetails.CustomerId || "",
      Destination: firstPickup.Destination || "",
      Origin: firstPickup.Origin || "",
      Pckgs: firstPickup.NoOfPcs || "",
      weight: firstPickup.GrossWeight || "",
      DeliveryBoyId: editPodDetails.DeliveryBoyId || "",
      DeliveryDate: null,
      DestinationReletaion: editPodDetails.DestinationReletaion || "",
      Remark: editPodDetails.Remark || "",
      ReceivedBy: firstPickup.ReceivedBy || "",
      ReceiverMobile: firstPickup.ReceiverMobile || "",
      proofImage: editPodDetails?.PodImage?.[0]?.file || "",
      Status: editPodDetails.Status || "",
      VehicleNo: editPodDetails.VehicleNo || "",
      OpeningKm: editPodDetails.OpeningKm || "",
      ClosingKm: editPodDetails.ClosingKm || ""
    });

    // Prepare list for table display
    const detailsList = editPodDetails.PickupDetails?.map((item) => ({
      _id: item._id || "",
      DocketId: item.DocketId ?? "—", 
      ReceiverName: item.ReceiverName ?? "—",
      ReceiverMobile: item.ReceiverMobile ?? "—",
      Customer: item.Customer ?? "—",
      Consigner: item.Consigner ?? "—",
      Consignee: item.Consignee ?? "—",
      DeliveredDateTime: item.DeliveryDateAndTime
        ? dayjs(item.DeliveryDateAndTime).format("DD-MM-YYYY hh:mm A")
        : "—",
      previewUrl: item.PodImage?.[0]?.file || null,
        totalPkg: item.totalPkg ?? "—",
  totalVolumetrix: item.totalVolumetrix ?? "—-",
    })) || [];

    setDrsDetailsList(detailsList);

    // Optional: Set preview for the form if needed
    if (editPodDetails?.PodImage?.[0]?.file) {
      setPreviewUrl(editPodDetails.PodImage[0].file);
    }
  }
}, [editPodDetails]);


  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const checkFileType = (event) => {
    if (event.target.files && event.target.files[0]) {
      const selectedFile = event.target.files[0];
      const validExtensions = ["image/jpeg"]; // Only JPG

      if (validExtensions.includes(selectedFile.type)) {
        setFile(selectedFile);
        setPreviewUrl(URL.createObjectURL(selectedFile));
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid file type",
          text: "Only JPG files are allowed.",
          confirmButtonText: "OK",
        });
        event.target.value = null; // Clear input
      }
    }
  };

  useEffect(() => {
    const fetchBranchList = () => {
      dispatch(
        getOfficeList({
          page:  1,
          limit: 10000,
          search:"",
          role: "OfficeAdmin",
        })
      )
        .then((res) => {
          const branchData = res?.payload?.data || [];

          if (branchData.length === 0) {
            console.warn("No branch data available.");
          }

          const mappedBranches = branchData.map((item) => ({
            label: item.OfficeName,
            value: item.OfficeId,
          }));

          setBranchOptions(mappedBranches);
        })
        .catch((error) => {
          console.error("Error fetching branch list:", error);
        });
    };

    fetchBranchList();
  }, [dispatch]);

const fetchDrsList = async () => {
    try {
      const res = await dispatch(
        getAdminDRSList({
          page: 1,
          limit: 10000,
          search:"",
          OfficeId: role === roles?.OfficeAdmin ? officeId : "",
        })
      );

      const drsData = res?.payload?.data || [];

      const options = drsData.map((item) => {
        const pickup = item?.PickupDetails?.[0] || {};
        const status = item?.Status || "";

        return {
          label: item.DRSId,
          value: item.DRSId,
          OfficeId: item.OfficeId,
          DeliveryBoyId: item.DeliveryBoyId,
          CustomerId: item.CustomerId,
          Remark: item.Remark,
          DocketId: item.DocketId,
          Status: status,
          Destination: pickup?.Destination || "",
          Origin: pickup?.Origin || "",
          Cosignee: pickup?.Consignee || "",
          Cosigner: pickup?.Consigner || "",
          Pckgs: pickup?.NoOfPcs || "",
          weight: pickup?.GrossWeight || "",
          BookingDate: pickup?.updatedAt || "",
          ArrivalTime: status === "PickedUp" ? pickup?.updatedAt || "" : "",
          proofImage: item?.PODImage?.[0]?.file || "",
        };
      });

      setDrsOptions(options);
    } catch (err) {
      console.error("Error fetching DRS list:", err);
    }
  };

  useEffect(() => {
    fetchDrsList();
  }, []);

  useEffect(() => {
    const fetchCustomerList = () => {
      dispatch(getCustomerList({ page: 1, limit: 10000, search: "" }))
        .then((res) => {
          const customerData = res?.payload?.data || [];
          if (customerData.length === 0) {
            console.warn("No customer data available.");
          }

          const mappedCustomer = customerData.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerId,
          }));

          setCustomerOptions(mappedCustomer);
        })
        .catch((error) => {
          console.error("Error fetching branch list:", error);
        });
    };

    fetchCustomerList();
  }, [dispatch]);


  // Fetch Docket list
  const fetchPickupList = async () => {
    try {
      const res = await dispatch(
        getDocket({
          page: 1,
          limit: 10000,
          search:"",
        })
      );

      const pickupData = res?.payload?.data || [];

      const mappedOptions = pickupData.map((item) => ({
        label: item.DocketId,
        value: item.DocketId,
      }));

      setPickupIdOptions(mappedOptions);
    } catch (error) {
      console.error("Error fetching pickup list:", error);
    }
  };


  useEffect(() => {
    fetchPickupList();
  }, []);

  useEffect(() => {
    // Determine the correct officeId based on the role
    const finalOfficeId = drsDetails?.OfficeId;

    if (!finalOfficeId) return;

    const fetchDeliveryBoyList = async () => {
      try {
        const res = await dispatch(
          getDeliveryBoyList({
            OfficeId: finalOfficeId,
            page: 1,
            limit: 10000,
          })
        );

        const modeData = res?.payload?.data || [];
        if (modeData.length === 0) {
          console.warn("No branch data available.");
        }

        const mappedMode = modeData.map((item) => ({
          label: item.AdminName,
          value: item.DeliveryBoyId,
        }));

        setDeliveryBoyList(mappedMode);
      } catch (error) {
        console.error("Error fetching modetype list:", error);
      }
    };

    fetchDeliveryBoyList();
  }, [role, officeId, drsDetails?.OfficeId, dispatch]);

  // Agar SelectDropDown onChange ko event deta hai:
  let check_first_digit = drsDetails?.ReceiverMobile
    ? drsDetails?.ReceiverMobile[0]
    : 0;

  let validation_input = [
    {
      tagid: "OfficeId",
      text: drsDetails?.OfficeId ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Select OfficeId.",
      min: 1,
      max: 100,
    },
    {
      tagid: "DocketId",
      text: drsDetails?.DocketId ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Select OfficeId.",
      min: 1,
      max: 100,
    },
    {
      tagid: "drsId",
      text: drsDetails?.drsId ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Select DRS Id.",
      min: 1,
      max: 100,
    },

    {
      tagid: "BookingDate",
      text: drsDetails?.BookingDate ?? "",
      regex_name: "datetime",
      required: true,
      errmsg: "Please select the Booking Date/Time.",
      min: 1,
      max: 100,
    },
    {
      tagid: "ReceivedBy",
      text: drsDetails?.ReceivedBy ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please  Enter ReceivedBy.",
      min: 1,
      max: 100,
    },
    {
      tagid: "ArrivalTime",
      text: drsDetails?.ArrivalTime ?? "",
      regex_name: "datetime",
      required: true,
      errmsg: "Please select Arrival Date/Time.",
      min: 1,
      max: 100,
    },
    {
      tagid: "DeliveryDate",
      text: drsDetails?.DeliveryDate ?? "",
      regex_name: "datetime",
      required: true,
      errmsg: "Please select Delivery Date/Time.",
      min: 1,
      max: 100,
    },
    {
      tagid: "Destination",
      text: drsDetails?.Destination ?? "",
      regex_name: "alpha",
      required: true,
      errmsg: "Please select Destination",
      min: 1,
      max: 100,
    },
    {
      tagid: "Origin",
      text: drsDetails?.Origin ?? "",
      regex_name: "alpha",
      required: true,
      errmsg: "Please select Origin",
      min: 1,
      max: 100,
    },
    {
      tagid: "DeliveryBoyId",
      text: drsDetails?.DeliveryBoyId ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Select DeliveryBoy.",
      min: 1,
      max: 100,
    },
    {
      tagid: "CustomerId",
      text: drsDetails?.CustomerId ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Select Customer   .",
      min: 1,
      max: 100,
    },
    {
      tagid: "Cosignee",
      text: drsDetails?.Cosignee ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Select Cosignee.",
      min: 1,
      max: 100,
    },
    {
      tagid: "Cosigner",
      text: drsDetails?.Cosigner ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Select Cosigner.",
      min: 1,
      max: 100,
    },
    {
      tagid: "Remark",
      text: drsDetails?.Remark ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Enter Remark.",
      min: 1,
      max: 100,
    },
    {
      tagid: "DestinationReletaion",
      text: drsDetails?.DestinationReletaion ?? "",
      regex_name: "free_text",
      required: true,
      errmsg: "Please Enter  Destination/Reletaion.",
      min: 1,
      max: 100,
    },
    
  ];

  const onClickSubmitdrsDetails = () => {
    if (validate(validation_input)?.length == 0) {
      setLoader(true);
      const requestData = {
        OfficeId: drsDetails.OfficeId || "",
        DRSId: drsDetails.drsId || "",
        ArrivalDate: drsDetails.ArrivalTime || "",
        ConsigneeId: drsDetails.Cosignee || "",
        ConsignerId: drsDetails.Cosigner || "",
        BookingDate: drsDetails.BookingDate || "",
        CustomerId: drsDetails.CustomerId || "",
        DestinationId: drsDetails.Destination || "",
        OriginId: drsDetails.Origin || "",
        Packgs: drsDetails.Pckgs || "",
        Weight: drsDetails.weight || "",
        DeliveryBoyId: drsDetails.DeliveryBoyId || "",
        DeliveryDate: drsDetails.DeliveryDate || "",
        DestinationReletaion: drsDetails.DestinationReletaion || "",
        Remark: drsDetails.Remark || "",
        ReceivedBy: drsDetails.ReceivedBy || "",
        ReceiverMobile: drsDetails.ReceiverMobile || "",
        DocketId: drsDetails.DocketId || "",
      };

      if (Object.keys(editPodDetails)?.length === 0) {
        // Create Office Details
        dispatch(createPodDetails(requestData)).then((res) => {
          if (res.payload.success === false) {
            sweetalert("error", res?.payload?.message);
          } else {
            sweetalert("success", res?.payload?.message);
            // const createdPodId = res?.payload?.data?.PodId;

            // if (drsDetails.proofImage && createdPodId) {
            //   const formData = new FormData();
            //   formData.append("file", drsDetails.proofImage);
            //   formData.append("PodId", createdPodId);
            // //   formData.append("proofType", drsDetails.proofType || "sign");

            //   dispatch(uploadPodProof(formData)).then((uploadRes) => {
            //     if (uploadRes?.payload?.success === false) {
            //      sweetalert("error", uploadRes?.payload?.message);
            //       } else {
            //          sweetalert("success", uploadRes?.payload?.message);
            //              }
            //          navigate("/dashboard/podlist");
            //               setLoader(false);
            //      })
            // }
            // console.log("Uploading file:", drsDetails.proofImage);
            // console.log("PodId:", createdPodId);
            // console.log("ProofType:", drsDetails.proofType);

            setDrsDetails({
              OfficeId: "",
              DeliveryBoyId: "",
              CustomerId: "",
              Remark: "",
              // DocketId: "",
              Status: "",
              drsId: "",
              Destination: "",
              Origin: "",
              Cosignee: "",
              Cosigner: "",
              Pckgs: "",
              weight: "",
              BookingDate: null,
              ReceivedBy: "",
              ArrivalTime: null,
              ReceiverMobile: "",
              DeliveryDate: null,
              DestinationReletaion: "",
              DocketId: "",
              proofImage: null,
            });
            navigate("/dashboard/podlist");
          }
          setLoader(false);
        });
      } else {
        const updateRequestData = {
          ...requestData,
          PodId: editPodDetails?.PodId, // <-- yahan add karo
        };
        dispatch(updatePODDetails(updateRequestData)).then((res) => {
          if (res.payload.success === false) {
            sweetalert("error", res?.payload?.message);
          } else {
            sweetalert("success", res?.payload?.message);
            setDrsDetails({
              OfficeId: "",
              DeliveryBoyId: "",
              CustomerId: "",
              Remark: "",
              // DocketId: "",
              Status: "",
              drsId: "",
              Destination: "",
              Origin: "",
              Cosignee: "",
              Cosigner: "",
              Pckgs: "",
              weight: "",
              BookingDate: null,
              ReceivedBy: "",
              ArrivalTime: null,
              ReceiverMobile: "",
              DeliveryDate: null,
              DestinationReletaion: "",
              DocketId: "",
              proofImage: null,
            });
            navigate("/dashboard/podlist");
          }
          setLoader(false);
        });
      }
    } else {
      setError(validate(validation_input));
    }
  };

  const handleChangeBranch = (e) => {
    const selectedBranchId = e.target.value;
    setDrsDetails((prev) => ({
      ...prev,
      OfficeId: selectedBranchId,
    }));
  };
  const handleDrsChange= (e) => {
    const selectedValue = e?.target?.value || e?.value;
    const selectedDrs = drsOptions.find((item) => item.value === selectedValue);

    if (selectedDrs) {
      setDrsDetails((prevState) => ({
        ...prevState,
        ...drsDetails,
        drsId: selectedDrs.value,
        OfficeId: selectedDrs.OfficeId,
        DeliveryBoyId: selectedDrs.DeliveryBoyId,
        CustomerId: selectedDrs.CustomerId,
        Remark: selectedDrs.Remark,
        DocketId: selectedDrs.DocketId,
        Status: selectedDrs.Status,
        Destination: selectedDrs.Destination,
        Origin: selectedDrs.Origin,
        Cosignee: selectedDrs.Cosignee,
        Cosigner: selectedDrs.Cosigner,
        Pckgs: selectedDrs.Pckgs,
        weight: selectedDrs.weight,
        BookingDate: selectedDrs.BookingDate,
        ArrivalTime: selectedDrs.ArrivalTime || "",
        proofImage: selectedDrs.proofImage || "",
      }));
      if (selectedDrs.proofImage) {
      setPreviewUrl(selectedDrs.proofImage); // ✅ set preview from fetched file
    } else {
      setPreviewUrl(null);
    }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target || {};
    setDrsDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleGateInDateChange = (newValue) => {
    setDrsDetails((prev) => ({ ...prev, ArrivalTime: newValue }));
  };
  const handleGateOutDateChange = (newValue) => {
    setDrsDetails((prev) => ({ ...prev, DeliveryDate: newValue }));
  };

  const indianStates = State.getStatesOfCountry("IN");

  let allIndianCities = [];

  // Step 2: Loop over each state and get cities
  indianStates.forEach((state) => {
    const stateCities = City.getCitiesOfState("IN", state.isoCode);

    // Filter: Ensure each city is really in India (just in case)
    const filteredCities = stateCities.filter(city => city.countryCode === "IN");

    allIndianCities.push(...filteredCities);
  });

  // Step 3: Remove duplicate city names
  const citySet = new Set();
  const cityOptions = [];

  allIndianCities.forEach(city => {
    if (!citySet.has(city.name)) {
      citySet.add(city.name);
      cityOptions.push({
        label: city.name,
        value: city.name,
      });
    }
  });

  // Optional: Sort alphabetically
  cityOptions.sort((a, b) => a.label.localeCompare(b.label));

  const sweetalert = (variant, text) => {
    Swal.fire({
      icon: variant === "error" ? "error" : "success",
      title: text,
      button: "Ok!",
    });
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <HeaderName headerName={ "POD"} newdrsDetails={false} onClickBackButton={() => navigate("/dashboard/podlist")}/>
        <Box
          style={{
            backgroundColor: "#FFFFFF",
            margin: "5px 30px 5px 10px",
            border: "1px solid #FFFFF",
            borderRadius: "30px",
            overflowY: "scroll", // allow vertical scroll
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none",
            height: "500px",
          }}
        >
          <Grid
            container
            spacing={2}
            style={{
              display: "flex",
              padding: "20px 20px",
              flexDirection: "row",
              alignItems: "start",
              justifyContent: "start",
            }}
          >
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                DRS
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <SelectDropDown
                id="drsId"
                name="drsId"
                placeholder="Select DRS Id"
                options={drsOptions}
                value={drsDetails?.drsId}
                onChange={handleDrsChange}
                sx={{
                  p: 0.1,
                  mt: 0.5,
                  pl: 1,
                  height: "50px",
                  borderRadius: "10px",
                  width: "100%",
                   backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",
                  
                }}
                disabled={isFormDisabled}
              />

              <DisplayError error={error} fortagid="drsId" />
            </Grid>
            {/* <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Docket Id
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>

              <SelectDropDown
                id="DocketId"
                name="DocketId"
                placeholder="Select Docket Id"
                options={pickupIdOptions}
                value={drsDetails.DocketId}
                onChange={handleChange}
                sx={{
                  p: 0.1,
                  mt: 0.5,
                  pl: 1,
                  height: "50px",
                  borderRadius: "10px",
                  width: "100%",
                  backgroundColor: "#FFFFFF",
                  //   color: "#BEBEBE",
                }}
                disabled={isFormDisabled}
              />
              <DisplayError error={error} fortagid="DocketId" />
            </Grid> */}
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Office Name
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <SelectDropDown
               disabled={isFormDisabled}
                id="OfficeId"
                name="OfficeId"
                placeholder="Select Office Name"
                options={branchOptions}
                value={drsDetails?.OfficeId}
                onChange={handleChangeBranch}
                sx={{
                  p: 0.1,
                  mt: 0.5,
                  pl: 1,
                  height: "50px",
                  borderRadius: "10px",
                  width: "100%",
                   backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",
                }}
              />

              <DisplayError error={error} fortagid="OfficeId" />
            </Grid>

            {/* <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Customer Name
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <SelectDropDown
                id="CustomerId"
                name="CustomerId"
                placeholder="Select Customer Name"
                options={customerOptions}
                value={drsDetails?.CustomerId}
                onChange={handleChange}
                sx={{
                  p: 0.1,
                  mt: 0.5,
                  pl: 1,
                  height: "50px",
                  borderRadius: "10px",
                  width: "100%",
                 backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",
                }}
                disabled={isFormDisabled}
              />
              <DisplayError error={error} fortagid="CustomerId" />
            </Grid> */}

            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Origin City
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>

              <SelectDropDown
                id="Origin"
                name="Origin"
                placeholder="Select Origin City"
                options={cityOptions}
                value={drsDetails.Origin}
                onChange={handleChange}
                disabled
                sx={{ height: "50px", mt: 0.5, borderRadius: "10px", backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE", }}
              />

              <DisplayError error={error} fortagid="Origin" />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Destination City
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <SelectDropDown
                id="Destination"
                name="Destination"
                placeholder="Select Destination City"
                options={cityOptions}
                value={drsDetails.Destination || ""}
                onChange={handleChange}
                sx={{ height: "50px", mt: 0.5, borderRadius: "10px" , backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",}}
                disabled={isFormDisabled}
              />
              <DisplayError error={error} fortagid="Destination" />
            </Grid>
            {/* <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Cosignee
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <SelectDropDown
                id="Cosignee"
                name="Cosignee"
                placeholder="Select Customer Name"
                options={customerOptions}
                value={drsDetails?.Cosignee}
                onChange={handleChange}
                sx={{
                  p: 0.1,
                  mt: 0.5,
                  pl: 1,
                  height: "50px",
                  borderRadius: "10px",
                  width: "100%",
                  backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",
                }}
                disabled={isFormDisabled}
              />
              <DisplayError error={error} fortagid="Cosignee" />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Cosigner
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <SelectDropDown
                id="Cosigner"
                name="Cosigner"
                placeholder="Select Cosigner Name"
                options={customerOptions}
                value={drsDetails?.Cosigner}
                onChange={handleChange}
                sx={{
                  p: 0.1,
                  mt: 0.5,
                  pl: 1,
                  height: "50px",
                  borderRadius: "10px",
                  width: "100%",
                  backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",
                }}
                disabled={isFormDisabled}
              />
              <DisplayError error={error} fortagid="Cosigner" />
            </Grid> */}

            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Booking Date&Time
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DateTimePicker
                    name="BookingDate"
                    label="Select Booking Date & Time"
                    value={
                      drsDetails.BookingDate
                        ? dayjs(drsDetails.BookingDate)
                        : null
                    }
                    onChange={(newValue) =>
                      setDrsDetails({ ...drsDetails, BookingDate: newValue })
                    }
                    minDateTime={dayjs()}
                    sx={{ width: "100%", backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE", }}
                    slotProps={{
                      popper: { placement: "left" }, // Added prop to place the DateTimePicker upwards
                    }}
                    disabled={isFormDisabled}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <DisplayError error={error} fortagid="BookingDate" />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Arrival Date/Time
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DateTimePicker
                    name="ArrivalTime"
                    label="Select Arrival Date& Time"
                    value={
                      drsDetails?.ArrivalTime
                        ? dayjs(drsDetails.ArrivalTime)
                        : null
                    }
                    onChange={handleGateInDateChange}
                    minDateTime={dayjs()}
                    sx={{ width: "100%", backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",}}
                    slotProps={{
                      popper: { placement: "left" }, // Added prop to place the DateTimePicker upwards
                    }}
                    disabled={isFormDisabled}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <DisplayError error={error} fortagid="ArrivalTime" />
            </Grid>
            {/* <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Delivery Date/Time
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DateTimePicker
                    name="DeliveryDate"
                    label="Select Date & Time"
                    value={drsDetails?.DeliveryDate}
                    onChange={handleGateOutDateChange}
                    minDateTime={dayjs()}
                    sx={{ width: "100%", backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE", }}
                    slotProps={{
                      popper: { placement: "left" }, // Added prop to place the DateTimePicker upwards
                    }}
                    disabled={isFormDisabled}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <DisplayError error={error} fortagid="DeliveryDate" />
            </Grid> */}
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                DeliveryBoy Name
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <SelectDropDown
                id="DeliveryBoyId"
                name="DeliveryBoyId"
                placeholder="Select Delivery Boy "
                options={deliveryBoyList}
                value={drsDetails?.DeliveryBoyId}
                onChange={handleChange}
                sx={{
                  p: 0.1,
                  mt: 0.5,
                  pl: 1,
                  height: "50px",
                  borderRadius: "10px",
                  width: "100%",
                   backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",
                }}
                disabled={isFormDisabled}
              />
              <DisplayError error={error} fortagid="DeliveryBoyId" />
            </Grid>
            {/* <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Packages
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <InputBox
                value={drsDetails.Pckgs}
                onChange={handleChange}
                sx={{
                  p: 0.1,
                  mt: 0.5,
                  pl: 1,
                  height: "50px",
                  borderRadius: "10px",
                  width: "100%",
                  backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                  fontSize: "14px",
                  // width: "100%",
                }}
                placeholder="Enter  Pckgs"
                name="Pckgs"
                disabled={isFormDisabled}
              />
              <DisplayError error={error} fortagid="Pckgs" />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <H4FormLabel sx={{ color: ThemeColor.palette.InputTextColor }}>
                Weight
                <span style={{ color: "#FF0000", fontWeight: 700 }}>*</span>
              </H4FormLabel>
              <InputBox
                value={drsDetails.weight}
                onChange={handleChange}
                sx={{
                  p: 0.1,
                  mt: 0.5,
                  pl: 1,
                  height: "50px",
                  borderRadius: "10px",
                  width: "100%",
                  backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                  fontSize: "14px",
                  // width: "100%",
                }}
                placeholder="Enter Weight"
                name="weight"
                disabled={isFormDisabled}
              />
              <DisplayError error={error} fortagid="weight" />
            </Grid> */}
            
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
  <Table sx={{ mt: 3, mb: 2, border: "1px solid #ccc" }}>
    <TableHead>
      <TableRow>
        <TableCell sx={{ fontWeight: 'bold' }}>No.</TableCell>
          <TableCell sx={{ fontWeight: 'bold' }}>Docket Id</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Recieved Name</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Recieved Mobile</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Customer Name</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Consignee Name</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Consignor Name</TableCell>
        <TableCell sx={{ fontWeight: 'bold' }}>Total Pkg</TableCell>
<TableCell sx={{ fontWeight: 'bold' }}>Total Volumetrix</TableCell>

        <TableCell sx={{ fontWeight: 'bold' }}>Deliverd Date & Time</TableCell>

        <TableCell sx={{ fontWeight: 'bold' }}>POD Image</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
     {drsDetailsList?.length > 0 ? (
        drsDetailsList.map((item, index) => (
    <TableRow key={index}>
      <TableCell>{index + 1}</TableCell>
      <TableCell>{item.DocketId}</TableCell>
      <TableCell>{item.ReceiverName || '—'}</TableCell>
      <TableCell>{item.ReceiverMobile || '—'}</TableCell>
      <TableCell>{item.Customer}</TableCell>
      <TableCell>{item.Consigner}</TableCell>
      <TableCell>{item.Consignee}</TableCell>
      <TableCell>{item.totalPkg}</TableCell>
      <TableCell>{item.totalVolumetrix}</TableCell>
      <TableCell>{item.DeliveredDateTime || '—'}</TableCell>     
      <TableCell>
  {item.previewUrl ? (
    <Tooltip title="View POD Image">
      <IconButton
        onClick={() => {
          // Open in a new tab without triggering download
          const newWindow = window.open('', '_blank');
          if (newWindow) {
            newWindow.document.write(`
              <html>
                <head>
                  <title>POD Image</title>
                </head>
                <body style="margin:0;text-align:center;background:#f9f9f9">
                  <img src="${item.previewUrl}" alt="POD Image" style="max-width:100%; max-height:100vh; object-fit:contain;" />
                </body>
              </html>
            `);
            newWindow.document.close();
          }
        }}
        size="small"
        sx={{ color: '#1976d2' }}
      >
        <ImageIcon />
      </IconButton>
    </Tooltip>
  ) : (
    'No Image'
  )}
</TableCell>
  {!item.previewUrl && <TableCell>
    <IconButton
      component="label"
      size="small"
      sx={{
        color: "#fff",
        backgroundColor: "#1976d2",
        borderRadius: 1,
        "&:hover": { backgroundColor: "#1565c0" }
      }}
    >
      <CloudUploadIcon sx={{ fontSize: 16 }} />
      <input
        hidden
        accept="image/*"
        type="file"
        onChange={(e) => {
          const file = e.target.files && e.target.files[0];
          if (!file) {
            sweetalert("error", "Please select an image file.");
            e.target.value = "";
            return;
          }

          // Validate file is an image
          if (!file.type.startsWith('image/')) {
            sweetalert("error", "Please select a valid image file.");
            e.target.value = "";
            return;
          }

          setLoader(true);
          const formData = new FormData();
          formData.append("file", file);
          // Use item.id if _id is not available
          const podId = item.DocketId || item._id || "";
          formData.append("PodId", podId);

          // Check if we have a valid PodId before dispatching
          if (!podId) {
            sweetalert("error", "Invalid POD ID. Cannot upload image.");
            setLoader(false);
            e.target.value = "";
            return;
          }
          dispatch(uploadPodProof(formData)).then((uploadRes) => {
            if (uploadRes?.payload?.success === false) {
              sweetalert("error", uploadRes?.payload?.message);
            } else {
              sweetalert("success", uploadRes?.payload?.message);
              const uploadedPreviewUrl = uploadRes?.payload?.data?.file || null;
              setDrsDetailsList((curr) =>
                curr.map((row) =>
                  row._id === item._id ? { ...row, previewUrl: uploadedPreviewUrl } : row
                )
              );
            }
            setLoader(false);
            e.target.value = "";
          }).catch(error => {
            console.error("Upload error:", error);
            sweetalert("error", "An error occurred during upload.");
            setLoader(false);
            e.target.value = "";
          });
        }}
      />
    </IconButton>
  </TableCell>}
    </TableRow>
  ))
) : (
  <TableRow>
    <TableCell colSpan={5} align="center">
      No Data Found
    </TableCell>
  </TableRow>
)}

    </TableBody>
  </Table>
</Grid>



            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <H4FormLabel
                sx={{ color: ThemeColor.palette.InputTextColor, mb: 0.5 }}
              >
                Remarks{" "}
              </H4FormLabel>
              <TextArea
                id="Remark"
                textwidth={"100%"}
                style={{
                  width: "95%",
                  height: "40px",
                   backgroundColor: "	#E0E0E0",
                  color:"#BEBEBE",
                  fontFamily: "Inter",
                  border: "1px solid rgba(0, 0, 0, 0.3)",
                  // height: "60px",
                  borderRadius: "10px",
                  fontWeight: 400,
                  fontSize: "18px",
                  lineHeight: "28px",
                  padding: "10px 15px",
                }}
                placeholder="Enter the Remarks"
                name="Remark"
                value={drsDetails?.Remark}
                onChange={handleChange}
                disabled={isFormDisabled}
              ></TextArea>

              <DisplayError error={error} fortagid="Remark" />
            </Grid>

            <Grid size={{ xs: 12, sm: 10, md: 10, lg: 12 }}style={{ display: "flex", justifyContent: "center" }}>
              <Button id="cancel" onClick={() => navigate("/dashboard/podlist")} sx={{color: "#FFFFFF", backgroundColor: "grey", fontSize: "16px",fontWeight: "500",borderRadius: "10px", pl: 5, pr: 5, textTransform: "none", boxShadow: "0px 4px 6px #e1e1e1", mb: 2, letterSpacing: "1px", }}>
               Cancel
             </Button>

            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};

export default NewPOD;
